import * as ActionCable from "@rails/actioncable";

const wsProtocol = window.location.protocol === "https:" ? "wss://" : "ws://";

const consumer = ActionCable.createConsumer(`${wsProtocol}${window.location.host}/cable`);

export default consumer;